<template lang="pug">
  v-tooltip.suporte-fab(left)
    template(v-slot:activator="{ on }")
      v-btn.ma-0(fab, dark, color="primary", :href="linkSuporte", target="_blank", v-on="on", @click="contatarSuporte")
        v-icon support_agent
    span Falar com o Suporte
</template>

<script>
import { WHATSAPP_SUPORTE } from '@/util/onboarding';
import { registrarContatoSuporte } from '@/util/suporte';

export default {
  name: 'suporte-fab',

  data: () => ({
    linkSuporte: `https://api.whatsapp.com/send?phone=${WHATSAPP_SUPORTE}`,
  }),

  methods: {
    contatarSuporte () {
      registrarContatoSuporte('botao_flutuante', this.$root.estabelecimentoSelecionado);
    },
  },
};
</script>

<style lang="scss" scoped>
.suporte-fab {
  display: flex;
}
</style>
